import React, { Component } from 'react';
import firebase from './components/Firebase/firebase-pushnotification';
import ErrorBoundary from './components/error/ErrorBoundary';
import Routes from "./Routes";
import "./App.css";

let messaging = null;
class App extends Component {
    componentDidMount(){
        if (firebase.messaging.isSupported()) {
            messaging = firebase.messaging()
            Notification.requestPermission()
            .then(function (permission) {
                console.log("Notification permission granted.");
                return messaging.getToken()
            }).then(function(token) {
                localStorage.setItem('fcm_id', token);
            }).catch(function (err) {
              console.log("Unable to get permission to FCM.", err);
            });
        }
    }

    render() {
        return (
            <ErrorBoundary
            >
                <Routes />
            </ErrorBoundary>
        );
    }
}

export default App;
